import React, { useState, useEffect, useRef } from "react";
import "../../assets/vendors/mdi/css/materialdesignicons.min.css";
import { Link, useLocation } from "react-router-dom";
import { useRole } from "../contextApi/RoleContext";
import eventEmitter from "./eventEmitter";

const SideBarAdvanced = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSubmenuOpen, setIsSubmenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [subActiveMenu, setSubActiveMenu] = useState(null);
  const { setRole, role, setPermission, permission } = useRole();
  const [collapsed, setCollapsed] = useState(true);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const dropdownRef = useRef(null); // Reference for dropdown content
  const toggleButtonRef = useRef(null); // Reference for toggle button
  const [activeroles, setActiveRoles] = useState("");
  const [activeuser, setActiveUser] = useState("");
  const [submenuJustClicked, setSubmenuJustClicked] = useState(false);
  const [systemVisible, setSystemVisible] = useState({
    system: false,
    roles: false,
    users: false,
  });
  const [menus, setMenus] = useState([
    {
      id: "dashboard",
      title: "Dashboard",
      icon: "mdi-home",
      to: "/",
      pageId: "1",
    },
    // {
    //   id: "employee",
    //   title: "Employees",
    //   icon: "mdi-account-circle",
    //   to: "/employee",
    //   pageId: "2",
    // },
    // {
    //   id: "shopify-products",
    //   title: "Shopify Products",
    //   icon: "mdi-crosshairs-gps",
    //   to: "/shopify-products",
    //   pageId: "6",
    // },
    // {
    //   id: "shopify-extract",
    //   title: "Shopify Extract",
    //   icon: "mdi mdi-download",
    //   to: "/shopify-extract",
    //   pageId: "6",
    // },
    // {
    //   id: "catalog-list",
    //   title: "Products",
    //   icon: "mdi-crosshairs-gps",
    //   to: "/catalog-list",
    //   pageId: "3",
    // },
    // {
    //   id: "web-orders",
    //   title: "Web Orders",
    //   icon: "mdi-database",
    //   to: "/web-orders",
    //   pageId: "4",
    // },
    {
      id: "stores",
      title: "Stores",
      icon: "mdi-store",
      to: "#",
      pageId: "6",
      submenus: [
        {
          id: "All Stores",
          title: "All Stores",
          icon: "mdi-store",
          to: "/liststores",
          permissionId: "8",
        },
        {
          id: "Extracts",
          title: "Extracts",
          icon: "mdi-download",
          to: "/shopify-extract",
          permissionId: "8",
        },
        {
          id: "Theme Upload",
          title: "Theme Upload",
          icon: "mdi-download",
          to: "/themeupload",
          permissionId: "8",
        },
        
      ],
    },
    // {
    //   id: "purchase-orders",
    //   title: "Purchase Orders",
    //   icon: "mdi-database",
    //   to: "/purchase-orders",
    //   pageId: "5",
    // },
    // {
    //   id: "sales-report",
    //   title: "Sales Report",
    //   icon: "mdi-chart-line",
    //   to: "/sales-report-filter",
    //   pageId: "10",
    // },
    {
      id: "system",
      title: "System",
      icon: "mdi-settings",
      to: "#",
      pageId: "6",
      submenus: [
        {
          id: "roles",
          title: "Roles",
          icon: "mdi-shield-account",
          to: "/roles",
          permissionId: "8",
        },
        {
          id: "users",
          title: "Users",
          icon: "mdi-account-multiple",
          to: "/users",
          permissionId: "9",
        },
      ],
    },
  ]);
  const [updatedmenu, setUpdatedMenu] = useState([]);

  const location = useLocation();

  useEffect(() => {
    const filterMenusByPageId = () => {
      // Filter menus based on permissions
      const filteredMenus = menus.filter((menu) => {
        const permissions = permission.find(
          (perm) =>
            perm.category_id === menu.pageId && perm.view_permission === "1"
        );
        return Boolean(permissions);
      });
      setUpdatedMenu(filteredMenus);
    };
    filterMenusByPageId();
  }, [permission, menus]);

  useEffect(() => {
  const path = location.pathname;
  let found = false;
  updatedmenu.forEach((menu, idx) => {
    if (menu.submenus) {
      menu.submenus.forEach((submenu) => {
        if (submenu.to === path) {
          setActiveMenu(idx);
          setSubActiveMenu(submenu.id);
          if (!submenuJustClicked) {
          //  setIsSubmenuOpen(true);
          }
          found = true;
        }
      });
    }
    if (menu.to === path) {
      setActiveMenu(idx);
      setSubActiveMenu(null);
      setIsSubmenuOpen(false);
      found = true;
    }
  });
  if (!found) {
    setActiveMenu(null);
    setSubActiveMenu(null);
    setIsSubmenuOpen(false);
  }
  setSubmenuJustClicked(false); // Reset the flag after handling

  eventEmitter.on("triggerEvent", toggleSidebar);
  return () => {
    eventEmitter.off("triggerEvent", toggleSidebar);
  };
  // eslint-disable-next-line
}, [location.pathname, updatedmenu]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prevState) => !prevState);
  };

  const toggleSubmenu = () => {
    setIsSubmenuOpen(!isSubmenuOpen);
  };


  const closeMenus = () => {
    setIsSidebarOpen(false);
    setIsSubmenuOpen(false);
  };

  const handleMenuClick = (index, menu) => {
  if (menu.submenus) {
    if (activeMenu === index && isSubmenuOpen) {
      // If clicking the already open menu, toggle submenu
      toggleSubmenu();
    } else {
      setActiveMenu(index);
      setIsSubmenuOpen(true);
    }
  } else {
    setActiveMenu(index);
    setSubActiveMenu(null);
    setIsSubmenuOpen(false);
  }
};

 const handleSubmenuClick = (submenu) => {
  setSubActiveMenu(submenu.id);
  setIsSubmenuOpen(false);
  setIsSidebarOpen(false);
  setSubmenuJustClicked(true); // <-- Add this
};

  // Helper to check submenu permission
  const hasPermission = (permissionId) => {
    if (!permissionId) return true;
    return permission.some(
      (perm) =>
        perm.category_id === permissionId && perm.view_permission === "1"
    );
  };
console.log("submenu id check",subActiveMenu);
  // Helper to render submenus
  const renderSubmenu = (submenus) => (
    <div className={`submenu ${isSubmenuOpen ? "active" : ""}`}>
      <ul>
        
        {submenus
          .filter((submenu) => hasPermission(submenu.permissionId))
          .map((submenu) => (
            
            <Link
              key={submenu.id}
              to={submenu.to}
              style={{ color: "white", textDecoration: "none" }}
              className={`sub${subActiveMenu === submenu.id ? "active" : ""}`}
              onClick={() => handleSubmenuClick(submenu)}
            >
              <li>
                <i className={`mdi ${submenu.icon} menu-icon`}></i>
                <span style={{ marginLeft: "5px",fontSize:"13px" }}>{submenu.title}</span>
              </li>
            </Link>
          ))}
      </ul>
    </div>
  );

  return (
    <>
      <div
        className={`overlay ${isSidebarOpen || isSubmenuOpen ? "active" : ""}`}
        onClick={closeMenus}
      ></div>
      <div className={`sidebar ${isSidebarOpen ? "open" : ""}`}>
        <ul>
          {updatedmenu.map((menu, index) => (
            <li
              key={menu.id}
              className={activeMenu === index ? "active" : ""}
              onClick={() => handleMenuClick(index, menu)}
            >
              <Link
                to={menu.to}
                style={{ color: "white", textDecoration: "none" }}
                onClick={e => {
                  if (menu.submenus) e.preventDefault();
                }}
              >
                <i className={`mdi ${menu.icon} menu-icon`}></i>
                <span>{menu.title}</span>
              </Link>
              {/* Render submenu if this menu is active and has submenus */}
              {activeMenu === index && menu.submenus && isSubmenuOpen && renderSubmenu(menu.submenus)}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
};

export default SideBarAdvanced;